import { useCallback } from 'react';
import { SAM_ACTION_EVENT_NAMES } from '@uber/label-modalities/src/analytics/event-name';
import useAnalytics from '../../../analytics/useAnalytics';
import type { RejectSAMSuggestionPayloadT, Sam3AutoDetectCancelAllPayloadT, Sam3AutoDetectResultPayloadT, Sam3AutoDetectSubmitAllPayloadT, Sam3AutoDetectTriggeredPayloadT, Sam3MaskToPolygonPayloadT, Sam3TightnessAdjustedPayloadT, SAMTools } from './types';
export type SAMAcceptedEventPayload = {
  automationRequestId: string;
  annotationId: string;
  toolName: SAMTools;
  modelUsed: 'SAM2' | 'SAM3';
};
export type SAMRejectedEventPayload = {
  automationRequestId: string;
  toolName: SAMTools;
  modelUsed: 'SAM2' | 'SAM3';
};
const useAnalyticsForSAM = () => {
  const {
    sendEvent
  } = useAnalytics();
  const sendEventSAMAccepted = useCallback(({
    annotationId,
    automationRequestId,
    toolName,
    modelUsed
  }: SAMAcceptedEventPayload) => {
    sendEvent({
      action: SAM_ACTION_EVENT_NAMES.ACCEPT_SAM_SUGGESTION,
      payload: {
        automationRequestId,
        objectId: annotationId,
        objectType: toolName,
        modelUsed
      }
    });
  }, [sendEvent]);
  const sendEventSAMRejected = useCallback(({
    automationRequestId,
    toolName,
    modelUsed
  }: SAMRejectedEventPayload) => {
    sendEvent({
      action: SAM_ACTION_EVENT_NAMES.REJECT_SAM_SUGGESTION,
      payload: ({
        automationRequestId,
        objectType: toolName,
        modelUsed
      } as RejectSAMSuggestionPayloadT)
    });
  }, [sendEvent]);
  const sendEventSam3MaskToPolygon = useCallback((payload: Sam3MaskToPolygonPayloadT) => {
    sendEvent({
      action: SAM_ACTION_EVENT_NAMES.SAM3_MASK_TO_POLYGON,
      payload
    });
  }, [sendEvent]);
  const sendEventSam3AutoDetectTriggered = useCallback((payload: Sam3AutoDetectTriggeredPayloadT) => {
    sendEvent({
      action: SAM_ACTION_EVENT_NAMES.SAM3_AUTO_DETECT_TRIGGERED,
      payload
    });
  }, [sendEvent]);
  const sendEventSam3AutoDetectResult = useCallback((payload: Sam3AutoDetectResultPayloadT) => {
    sendEvent({
      action: SAM_ACTION_EVENT_NAMES.SAM3_AUTO_DETECT_RESULT,
      payload
    });
  }, [sendEvent]);
  const sendEventSam3AutoDetectSubmitAll = useCallback((payload: Sam3AutoDetectSubmitAllPayloadT) => {
    sendEvent({
      action: SAM_ACTION_EVENT_NAMES.SAM3_AUTO_DETECT_SUBMIT_ALL,
      payload
    });
  }, [sendEvent]);
  const sendEventSam3AutoDetectCancelAll = useCallback((payload: Sam3AutoDetectCancelAllPayloadT) => {
    sendEvent({
      action: SAM_ACTION_EVENT_NAMES.SAM3_AUTO_DETECT_CANCEL_ALL,
      payload
    });
  }, [sendEvent]);
  const sendEventSam3TightnessAdjusted = useCallback((payload: Sam3TightnessAdjustedPayloadT) => {
    sendEvent({
      action: SAM_ACTION_EVENT_NAMES.SAM3_TIGHTNESS_ADJUSTED,
      payload
    });
  }, [sendEvent]);
  return {
    sendEventSAMAccepted,
    sendEventSAMRejected,
    sendEventSam3MaskToPolygon,
    sendEventSam3AutoDetectTriggered,
    sendEventSam3AutoDetectResult,
    sendEventSam3AutoDetectSubmitAll,
    sendEventSam3AutoDetectCancelAll,
    sendEventSam3TightnessAdjusted
  };
};
export default useAnalyticsForSAM;